import getProductStockStatus from "core-web/utils/getProductStockStatus";

export default (product) => {
    if (!product) {
        return null;
    }

    const {
        name,
        description_header: descHeader,
        image_key: image,
        manufacturer,
        price: priceExVat,
        price_standard: standardPriceExVat,
        price_list_id: priceListId,
        price_list_code: priceListCode,
        vat_rate: vatRate,
        id: productId,
        url,
        part_no: partNo,
        on_hand: onHand,
        variants = [],
        parametrics = {},
        flags = [],
        format,
    } = product;

    const isVariant = variants.length > 1;
    const stockStatus = onHand ? getProductStockStatus(onHand) : { stock: 0, leadTime: null, nextDelivery: null };
    const inStock = !!stockStatus.stock;
    const manufacturerName = manufacturer?.name;
    const productFlags = format?.flags || flags;

    return {
        partNo: partNo || variants?.[0]?.part_no || String(productId),
        name: descHeader || name,
        priceExVat,
        standardPriceExVat,
        vatRate,
        priceListId,
        priceListCode,
        flags: productFlags,
        manufacturerName,
        url,
        parametrics,
        image,
        isVariant,
        productId,
        stockStatus,
        inStock,
        isPackage: false,
    };
};
